interface NodeLike {
	type: { name: string }
	attrs: Record<string, unknown>
}

interface DocLike {
	descendants: (fn: (node: NodeLike) => boolean | void) => void
}

interface AttachmentUploadState {
	state: "loading" | "uploaded" | "error"
	url?: string | null
}

// An upload that failed is removed from the list and one that succeeded carries
// its CDN url, so "no url" and "loading" both mean the file is not on the wire yet.
export const hasUnfinishedAttachment = (
	attachments: AttachmentUploadState[],
): boolean => attachments.some(({ state, url }) => state === "loading" || !url)

// The composer previews a pasted image from its data URL until the CDN upload
// swaps the src, and mail clients drop a data URI, so this is an image the
// recipient would never see.
export const isUnuploadedImageSrc = (src: unknown): boolean =>
	typeof src === "string" && src.startsWith("data:")

export const hasUnuploadedInlineImage = (
	doc: DocLike | null | undefined,
): boolean => {
	if (!doc) return false
	let found = false
	doc.descendants((node) => {
		if (found) return false
		if (node.type.name === "image" && isUnuploadedImageSrc(node.attrs.src)) {
			found = true
			return false
		}
		return true
	})
	return found
}
